<script lang="ts">
    import OpenGraph from "./OpenGraph.svelte"
    import Product from "./Product.svelte"
    import SchemaOrg from "./SchemaORG.svelte"
    import { websiteName, baseURL } from "../../configs/config"
    import DefaultHeader from "./DefaultHeader.svelte"

    interface SEOProps {
        // article?: boolean // isArticle – bei Bedarf aktivieren
        createdAt?: Date | null
        updatedAt?: Date | null
        metaDescription?: string
        metaKeywords?: string
        title?: string
        product?: TProduct | null
        noIndex?: boolean
        active?: boolean
        canonicalPath?: string
        FAQ?: boolean
        FAQDetails?: {
            question?: string
            answer?: string
        }[]
    }

    let {
        // article = false, // isArticle – bei Bedarf aktivieren
        createdAt = null,
        updatedAt = null,
        metaDescription = "",
        metaKeywords = "",
        title = "",
        product = null,
        noIndex = false,
        active = true,
        canonicalPath = "",
        FAQ = false,
        FAQDetails = [],
    }: SEOProps = $props()

    const pageTitle: string = title ? `${title} - ${websiteName}` : `${websiteName}`

    const openGraphProps = {
        // article, // isArticle – bei Bedarf aktivieren
        datePublished: createdAt,
        lastUpdated: updatedAt,
        metaDescription,
        pageTitle,
        product,
    }
    const schemaOrgProps = {
        createdAt,
        updatedAt,
        // article, // isArticle – bei Bedarf aktivieren
        description: metaDescription,
        title: pageTitle,
        product,
        FAQ,
        FAQDetails,
    }
</script>

<DefaultHeader
    {pageTitle}
    {metaDescription}
    {metaKeywords}
    {noIndex}
    {active}
    canonical={product ? "" : canonicalPath ? `${baseURL}${canonicalPath.replace(/\/+$/, "")}` : ""}
/>
{#if product}
    <Product {product} />
{/if}
<OpenGraph {...openGraphProps} />

{#if typeof window == "undefined"}
    <SchemaOrg {...schemaOrgProps} />
{/if}
